import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Loader2 } from "lucide-react"

interface Location {
  id: number
  code: string
  name_th: string
  name_en: string
}

interface ThaiLocationSelectProps {
  label: string
  placeholder: string
  value: string
  onChange: (value: string, id: number) => void
  options: Location[]
  loading?: boolean
  disabled?: boolean
  required?: boolean
  error?: string
  className?: string
}

export function ThaiLocationSelect({
  label,
  placeholder,
  value,
  onChange,
  options,
  loading = false,
  disabled = false,
  required = false,
  error,
  className = ""
}: ThaiLocationSelectProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      <Label className="text-[#323130] font-medium">
        {label} {required && <span className="text-red-500">*</span>}
      </Label>
      <Select
        value={value}
        onValueChange={(nameTh) => {
          const selected = options.find(opt => opt.name_th === nameTh)
          if (selected) {
            onChange(nameTh, selected.id)
          }
        }}
        disabled={disabled || loading}
      >
        <SelectTrigger className="bg-white border-[#d1d1d1] text-[#323130] h-10">
          {loading ? (
            <div className="flex items-center gap-2 text-[#949494]">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>กำลังโหลด...</span>
            </div>
          ) : value ? (
            <span>{value}</span>
          ) : (
            <SelectValue placeholder={placeholder} />
          )}
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          {options.length === 0 && !loading ? (
            <div className="py-6 text-center text-sm text-[#949494]">
              ไม่พบข้อมูล
            </div>
          ) : (
            options.map((option) => (
              <SelectItem 
                key={option.id} 
                value={option.name_th}
                className="cursor-pointer"
              >
                {option.name_th}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
      {error && (
        <p className="text-sm text-red-500 mt-1">{error}</p>
      )}
    </div>
  )
}
